var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"page-wrap"},[_c('div',{staticClass:"content-part"},[_c('div',{staticClass:"container"},[_c('DetailContent')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }